import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SuperImageRequest, SuperImageResponse } from '../components/super-image-studio/super-image-studio.models';

@Injectable({
  providedIn: 'root'
})
export class SuperImageStudioService {
  private readonly endpoint = environment?.stabilityStudioEndpoint ?? 'https://your-api-gateway-url.amazonaws.com/studio';

  constructor(private http: HttpClient) {}

  run(request: SuperImageRequest): Observable<SuperImageResponse> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<SuperImageResponse>(this.endpoint, request, { headers });
  }

  fileToBase64(file: File): Observable<string> {
    return new Observable((observer) => {
      const reader = new FileReader();
      reader.onload = () => {
        observer.next(reader.result as string);
        observer.complete();
      };
      reader.onerror = (error) => observer.error(error);
      reader.readAsDataURL(file);
    });
  }

  buildDataUrl(image: string, format: SuperImageResponse['output_format']): string {
    return `data:image/${format};base64,${image}`;
  }
}
